import { FullValidationErrorFragment } from '@common/graphql/fragments';
import { gql, TypedDocumentNode } from '@common/hooks';
import {
  CreateWorkforceGroupMutationCgResponse,
  CreateWorkforceGroupMutationVariables,
  UpdateWorkforceGroupMutationCgResponse,
  UpdateWorkforceGroupMutationVariables,
  UpdateWorkforceGroupOrgBusinessConfigMutationCgResponse,
  UpdateWorkforceGroupOrgBusinessConfigMutationVariables,
  ArchiveWorkforceGroupMutationCgResponse,
  ArchiveWorkforceGroupMutationVariables,
} from '@common/graphql/schema';

export const CreateWorkforceGroup: TypedDocumentNode<
  CreateWorkforceGroupMutationCgResponse,
  CreateWorkforceGroupMutationVariables
> = gql`
  mutation CreateWorkforceGroup($input: CreateWorkforceGroupInput!) {
    createWorkforceGroup(input: $input) {
      workforceGroup {
        id
        name
      }
      errors {
        ...FullValidationErrorFragment
      }
    }
  }
  ${FullValidationErrorFragment}
`;

export const UpdateWorkforceGroup: TypedDocumentNode<
  UpdateWorkforceGroupMutationCgResponse,
  UpdateWorkforceGroupMutationVariables
> = gql`
  mutation UpdateWorkforceGroup($input: UpdateWorkforceGroupInput!) {
    updateWorkforceGroup(input: $input) {
      workforceGroup {
        id
        name
      }
      errors {
        ...FullValidationErrorFragment
      }
    }
  }
  ${FullValidationErrorFragment}
`;

export const UpdateWorkforceGroupOrgBusinessConfig: TypedDocumentNode<
  UpdateWorkforceGroupOrgBusinessConfigMutationCgResponse,
  UpdateWorkforceGroupOrgBusinessConfigMutationVariables
> = gql`
  mutation UpdateWorkforceGroupOrgBusinessConfig(
    $input: UpdateWorkforceGroupOrgBusinessConfigInput!
  ) {
    updateWorkforceGroupOrgBusinessConfig(input: $input) {
      workforceGroupOrganizationBusinessConfig {
        id
      }
      errors {
        ...FullValidationErrorFragment
      }
    }
  }
  ${FullValidationErrorFragment}
`;

export const ArchiveWorkforceGroup: TypedDocumentNode<
  ArchiveWorkforceGroupMutationCgResponse,
  ArchiveWorkforceGroupMutationVariables
> = gql`
  mutation ArchiveWorkforceGroup($input: ArchiveWorkforceGroupInput!) {
    archiveWorkforceGroup(input: $input) {
      workforceGroup {
        id
        name
      }
      errors {
        ...FullValidationErrorFragment
      }
    }
  }
  ${FullValidationErrorFragment}
`;
